import getListViewStore from "../store/Store";
import type ConversationItem from "../store/schema/ConversationItem";

export default function selectConversationById(conversationId: string): ConversationItem {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'ConversationItem | undefined' is not assignable to type 'ConversationItem'.
    // @ts-expect-error
    return getListViewStore().conversationItems.get(conversationId);
}
